var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 114,
    viewBox: "0 0 111 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 13.2979C5.48381 13.2979 5.76813 13.0278 5.76813 12.6946C5.76813 12.3614 5.48381 12.0913 5.13309 12.0913C4.78236 12.0913 4.49805 12.3614 4.49805 12.6946C4.49805 13.0278 4.78236 13.2979 5.13309 13.2979Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 15.7362C5.48381 15.7362 5.76813 15.466 5.76813 15.1328C5.76813 14.7997 5.48381 14.5295 5.13309 14.5295C4.78236 14.5295 4.49805 14.7997 4.49805 15.1328C4.49805 15.466 4.78236 15.7362 5.13309 15.7362Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 18.1746C5.48381 18.1746 5.76813 17.9045 5.76813 17.5713C5.76813 17.2381 5.48381 16.968 5.13309 16.968C4.78236 16.968 4.49805 17.2381 4.49805 17.5713C4.49805 17.9045 4.78236 18.1746 5.13309 18.1746Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 20.588C5.48381 20.588 5.76813 20.3179 5.76813 19.9847C5.76813 19.6515 5.48381 19.3813 5.13309 19.3813C4.78236 19.3813 4.49805 19.6515 4.49805 19.9847C4.49805 20.3179 4.78236 20.588 5.13309 20.588Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 23.0262C5.48381 23.0262 5.76813 22.7561 5.76813 22.4229C5.76813 22.0897 5.48381 21.8196 5.13309 21.8196C4.78236 21.8196 4.49805 22.0897 4.49805 22.4229C4.49805 22.7561 4.78236 23.0262 5.13309 23.0262Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 25.4395C5.48381 25.4395 5.76813 25.1694 5.76813 24.8362C5.76813 24.503 5.48381 24.2329 5.13309 24.2329C4.78236 24.2329 4.49805 24.503 4.49805 24.8362C4.49805 25.1694 4.78236 25.4395 5.13309 25.4395Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 27.8778C5.48381 27.8778 5.76813 27.6076 5.76813 27.2744C5.76813 26.9413 5.48381 26.6711 5.13309 26.6711C4.78236 26.6711 4.49805 26.9413 4.49805 27.2744C4.49805 27.6076 4.78236 27.8778 5.13309 27.8778Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 30.3162C5.48381 30.3162 5.76813 30.0461 5.76813 29.7129C5.76813 29.3797 5.48381 29.1096 5.13309 29.1096C4.78236 29.1096 4.49805 29.3797 4.49805 29.7129C4.49805 30.0461 4.78236 30.3162 5.13309 30.3162Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 32.7293C5.48381 32.7293 5.76813 32.4592 5.76813 32.126C5.76813 31.7928 5.48381 31.5227 5.13309 31.5227C4.78236 31.5227 4.49805 31.7928 4.49805 32.126C4.49805 32.4592 4.78236 32.7293 5.13309 32.7293Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 35.1678C5.48381 35.1678 5.76813 34.8977 5.76813 34.5645C5.76813 34.2313 5.48381 33.9612 5.13309 33.9612C4.78236 33.9612 4.49805 34.2313 4.49805 34.5645C4.49805 34.8977 4.78236 35.1678 5.13309 35.1678Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 37.5811C5.48381 37.5811 5.76813 37.311 5.76813 36.9778C5.76813 36.6446 5.48381 36.3745 5.13309 36.3745C4.78236 36.3745 4.49805 36.6446 4.49805 36.9778C4.49805 37.311 4.78236 37.5811 5.13309 37.5811Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 40.0194C5.48381 40.0194 5.76813 39.7492 5.76813 39.4161C5.76813 39.0829 5.48381 38.8127 5.13309 38.8127C4.78236 38.8127 4.49805 39.0829 4.49805 39.4161C4.49805 39.7492 4.78236 40.0194 5.13309 40.0194Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 42.4327C5.48381 42.4327 5.76813 42.1626 5.76813 41.8294C5.76813 41.4962 5.48381 41.2261 5.13309 41.2261C4.78236 41.2261 4.49805 41.4962 4.49805 41.8294C4.49805 42.1626 4.78236 42.4327 5.13309 42.4327Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 44.8709C5.48381 44.8709 5.76813 44.6008 5.76813 44.2676C5.76813 43.9344 5.48381 43.6643 5.13309 43.6643C4.78236 43.6643 4.49805 43.9344 4.49805 44.2676C4.49805 44.6008 4.78236 44.8709 5.13309 44.8709Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 47.3094C5.48381 47.3094 5.76813 47.0393 5.76813 46.7061C5.76813 46.3729 5.48381 46.1028 5.13309 46.1028C4.78236 46.1028 4.49805 46.3729 4.49805 46.7061C4.49805 47.0393 4.78236 47.3094 5.13309 47.3094Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 49.7225C5.48381 49.7225 5.76813 49.4524 5.76813 49.1192C5.76813 48.786 5.48381 48.5159 5.13309 48.5159C4.78236 48.5159 4.49805 48.786 4.49805 49.1192C4.49805 49.4524 4.78236 49.7225 5.13309 49.7225Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 52.161C5.48381 52.161 5.76813 51.8908 5.76813 51.5577C5.76813 51.2245 5.48381 50.9543 5.13309 50.9543C4.78236 50.9543 4.49805 51.2245 4.49805 51.5577C4.49805 51.8908 4.78236 52.161 5.13309 52.161Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 54.5743C5.48381 54.5743 5.76813 54.3042 5.76813 53.971C5.76813 53.6378 5.48381 53.3677 5.13309 53.3677C4.78236 53.3677 4.49805 53.6378 4.49805 53.971C4.49805 54.3042 4.78236 54.5743 5.13309 54.5743Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 57.0125C5.48381 57.0125 5.76813 56.7424 5.76813 56.4092C5.76813 56.076 5.48381 55.8059 5.13309 55.8059C4.78236 55.8059 4.49805 56.076 4.49805 56.4092C4.49805 56.7424 4.78236 57.0125 5.13309 57.0125Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 59.4259C5.48381 59.4259 5.76813 59.1557 5.76813 58.8226C5.76813 58.4894 5.48381 58.2192 5.13309 58.2192C4.78236 58.2192 4.49805 58.4894 4.49805 58.8226C4.49805 59.1557 4.78236 59.4259 5.13309 59.4259Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 61.8641C5.48381 61.8641 5.76813 61.594 5.76813 61.2608C5.76813 60.9276 5.48381 60.6575 5.13309 60.6575C4.78236 60.6575 4.49805 60.9276 4.49805 61.2608C4.49805 61.594 4.78236 61.8641 5.13309 61.8641Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 64.3026C5.48381 64.3026 5.76813 64.0325 5.76813 63.6993C5.76813 63.3661 5.48381 63.0959 5.13309 63.0959C4.78236 63.0959 4.49805 63.3661 4.49805 63.6993C4.49805 64.0325 4.78236 64.3026 5.13309 64.3026Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 66.7157C5.48381 66.7157 5.76813 66.4455 5.76813 66.1123C5.76813 65.7791 5.48381 65.509 5.13309 65.509C4.78236 65.509 4.49805 65.7791 4.49805 66.1123C4.49805 66.4455 4.78236 66.7157 5.13309 66.7157Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 69.1541C5.48381 69.1541 5.76813 68.884 5.76813 68.5508C5.76813 68.2176 5.48381 67.9475 5.13309 67.9475C4.78236 67.9475 4.49805 68.2176 4.49805 68.5508C4.49805 68.884 4.78236 69.1541 5.13309 69.1541Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 71.5675C5.48381 71.5675 5.76813 71.2973 5.76813 70.9641C5.76813 70.6309 5.48381 70.3608 5.13309 70.3608C4.78236 70.3608 4.49805 70.6309 4.49805 70.9641C4.49805 71.2973 4.78236 71.5675 5.13309 71.5675Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 74.0057C5.48381 74.0057 5.76813 73.7356 5.76813 73.4024C5.76813 73.0692 5.48381 72.7991 5.13309 72.7991C4.78236 72.7991 4.49805 73.0692 4.49805 73.4024C4.49805 73.7356 4.78236 74.0057 5.13309 74.0057Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 76.419C5.48381 76.419 5.76813 76.1489 5.76813 75.8157C5.76813 75.4825 5.48381 75.2124 5.13309 75.2124C4.78236 75.2124 4.49805 75.4825 4.49805 75.8157C4.49805 76.1489 4.78236 76.419 5.13309 76.419Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 78.8572C5.48381 78.8572 5.76813 78.5871 5.76813 78.2539C5.76813 77.9207 5.48381 77.6506 5.13309 77.6506C4.78236 77.6506 4.49805 77.9207 4.49805 78.2539C4.49805 78.5871 4.78236 78.8572 5.13309 78.8572Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 81.2957C5.48381 81.2957 5.76813 81.0256 5.76813 80.6924C5.76813 80.3592 5.48381 80.0891 5.13309 80.0891C4.78236 80.0891 4.49805 80.3592 4.49805 80.6924C4.49805 81.0256 4.78236 81.2957 5.13309 81.2957Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 83.7088C5.48381 83.7088 5.76813 83.4387 5.76813 83.1055C5.76813 82.7723 5.48381 82.5022 5.13309 82.5022C4.78236 82.5022 4.49805 82.7723 4.49805 83.1055C4.49805 83.4387 4.78236 83.7088 5.13309 83.7088Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13309 86.1473C5.48381 86.1473 5.76813 85.8772 5.76813 85.544C5.76813 85.2108 5.48381 84.9407 5.13309 84.9407C4.78236 84.9407 4.49805 85.2108 4.49805 85.544C4.49805 85.8772 4.78236 86.1473 5.13309 86.1473Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13318 96.2778C4.44522 96.2778 3.91602 95.7499 3.91602 95.1214V88.7113C3.91602 88.0577 4.47168 87.5549 5.13318 87.5549C5.82114 87.5549 6.35034 88.0828 6.35034 88.7113V95.1214C6.3768 95.7499 5.82114 96.2778 5.13318 96.2778Z",
    fill: "white",
    stroke: "#878787",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M105.708 9.02441H9.84326V109.425H105.708V9.02441Z",
    fill: "#EDEDED",
    stroke: "#878787",
    strokeWidth: 0.9958,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M105.708 9.02441H9.84326V80.5666H105.708V9.02441Z",
    fill: "#D2D2D2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M107.216 9.75353H3.57231C2.32869 7.06378 2.19639 4.3489 3.57231 1.58374H107.216C108.857 4.32376 108.857 7.03865 107.216 9.75353Z",
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftImg);
export default __webpack_public_path__ + "static/media/left_img.6631dd49999ed0aa4f4f4fe43fdbe99a.svg";
export { ForwardRef as ReactComponent };